import type { ButtonProps } from '@archipro-design/aria';
import {
    Button,
    Flex,
    pxToRem,
    useStyles,
    useTheme,
} from '@archipro-design/aria';
import { ExternalLinkLine, InboxCustom } from '@archipro-design/icons';
import * as S from './PageDetailHeaderCTA.style';
import { Link } from '@remix-run/react';
import { useWebsiteReferralTracking } from '~/modules/tracking/util/websiteTracking';

import cx from 'classnames';

export type CTAHeaderType = 'Product' | 'Article';
interface PageDetailHeaderCTAProps {
    pageType: CTAHeaderType;
    pageID: number;
    website?: string | null;
    primaryCTAButtonLabel?: string;
    primaryCTAButtonOnClick?: () => void;
    primaryCTAButtonLink?: string;
    //This is bad - will fix up with the rest of this later
    professionalID?: number;
    professionalTitle: string;
    // allow primaryCTAButton style override
    primaryCTAButtonProps?: Partial<ButtonProps>;
}

const PageDetailHeaderCTA = ({
    pageType,
    pageID,
    website,
    primaryCTAButtonLabel,
    primaryCTAButtonOnClick,
    primaryCTAButtonLink,
    professionalTitle,
    primaryCTAButtonProps,
}: PageDetailHeaderCTAProps) => {
    const { css } = useStyles({ pageType });

    const theme = useTheme();

    const {
        referralTrackingURL,
        referralTrackingClass,
        referralTrackingParams,
    } = useWebsiteReferralTracking(website ?? undefined, {
        libraryItemID: pageID,
        professionalTitle,
    });

    return (
        <div className={css(S.CTAButtonContainer)}>
            <Flex gap="space-16">
                {referralTrackingURL && (
                    <Button
                        className={cx(
                            css(S.HeaderButton),
                            referralTrackingClass
                        )}
                        size={16}
                        color="dark"
                        variant="outlined"
                        as={'a'}
                        href={referralTrackingURL}
                        target={'_blank'}
                        iconAfter={<ExternalLinkLine />}
                        variables={{
                            iconPadding: 0,

                            buttonSize16IconXMargin: pxToRem(10),
                            darkOutlinedButtonBorderNormal: `1px solid ${theme.siteVariables.colors.charcoal['250']}`,
                            darkOutlinedButtonBorderHover: `1px solid ${theme.siteVariables.colors.charcoal['250']}`,
                            darkOutlinedButtonBorderDisable: `1px solid ${theme.siteVariables.colors.charcoal['250']}`,
                        }}
                        {...referralTrackingParams}
                    >
                        Visit Website
                    </Button>
                )}
            </Flex>
            {primaryCTAButtonLabel && (
                <Flex gap="space-8">
                    {primaryCTAButtonLink && (
                        <Button
                            size={16}
                            color="dark"
                            outlined={true}
                            className={css(S.HeaderButton)}
                            as={Link}
                            to={primaryCTAButtonLink}
                            iconAfter={<InboxCustom />}
                            {...primaryCTAButtonProps}
                            variables={{
                                ...primaryCTAButtonProps?.variables,
                                iconPadding: 0,
                                buttonSize16IconXMargin: pxToRem(10),
                                darkButtonBorderNormal: 'none',
                            }}
                        >
                            {primaryCTAButtonLabel}
                        </Button>
                    )}

                    {!primaryCTAButtonLink && primaryCTAButtonOnClick && (
                        <Button
                            className={css(S.HeaderButton)}
                            size={16}
                            color="dark"
                            onClick={primaryCTAButtonOnClick}
                            {...primaryCTAButtonProps}
                            iconAfter={<InboxCustom />}
                            variables={{
                                ...primaryCTAButtonProps?.variables,
                                iconPadding: 0,
                                buttonSize16IconXMargin: pxToRem(10),
                                darkButtonBorderNormal: 'none',
                            }}
                        >
                            {primaryCTAButtonLabel}
                        </Button>
                    )}
                </Flex>
            )}
        </div>
    );
};

export default PageDetailHeaderCTA;
